module.exports = __webpack_public_path__ + "img/printing.53bdeb96.svg";